import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Form } from 'antd';

import { Loader, MilesForm } from 'components';

import { useGetRequest, useUserRole } from 'hooks';
import { getIsNew } from 'utils';

import { ProductDetails } from 'codegen';

import { fields } from './lib';
import { ProductFormActions } from './ProductFormActions';

import { initProductSuccessAction, IProductStore, productStore } from '../../store';

const { useForm } = Form;

export const ProductForm = () => {
  const initialValues = productStore((state) => state.initialValues);

  const { productId } = useParams();
  const isNew = getIsNew(productId);

  const [form] = useForm<IProductStore['initialValues']>();

  const { loading } = useGetRequest<ProductDetails>({
    url: `/products/details/${productId}`,
    options: {
      ready: !isNew,
      refreshDeps: [productId],
      onSuccess: ({ data }) => initProductSuccessAction(data),
    },
  });

  useEffect(() => { form.resetFields(); }, [initialValues]);

  const { isAdmin } = useUserRole();

  return (
    <Loader isLoading={loading}>
      <MilesForm
        form={form}
        name='productForm'
        fields={fields}
        actions={<ProductFormActions />}
        disabled={!isAdmin}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={initialValues}
      />
    </Loader>
  );
};
